import axios from "axios";

export interface ChangePasswordProps {
    currentPassword: string,
    newPassword: string,
    confirmedPassword: string
}

export const changeAdminPassword = (passwordDetails: ChangePasswordProps, onProfileSuccess: (message: string) => void, onProfileFailure: (errMsg: string) => void) => {

    return async () => {

        await axios.patch('/admin/change-admin-password', passwordDetails)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    onProfileSuccess(response?.data?.message);
                } else {
                    onProfileFailure(response?.data?.message);
                }
            })
            .catch((err) => {
                onProfileFailure(err?.response?.data?.message)
            });
    }
}

